import React from 'react'
import SpecialConditions from '../Patient/SpecialConditions'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import moment from 'moment'
import _ from 'lodash'
import { getToken } from '../Commons/Authentication'
import AlergiasImage from '../../img/special-conditions/alergias.png'
import AnticuagImage from '../../img/special-conditions/anticuagulado.png'
import ControlPImage from '../../img/special-conditions/control_peso.png'
import CuidadoEImage from '../../img/special-conditions/cuidado_especial.png'
import DiabeticoImage from '../../img/special-conditions/diabetico.png'
import FaseIIImage from '../../img/special-conditions/fase2.png'
import FragilImage from '../../img/special-conditions/fragil.png'
import InactivoImage from '../../img/special-conditions/inactivo.png'
import OxigenoImage from '../../img/special-conditions/oxigeno_dependiente.png'
import ProgramaDImage from '../../img/special-conditions/programa_domiciliario.png'
import ReingresoImage from '../../img/special-conditions/reingreso.png'
import SaturacionImage from '../../img/special-conditions/saturacion_o2.png'

export default class MarcacionesComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({update: false, birthdate: null, obj: null})
  }
  saveSpecial (special) {
    let endpoint = 'api/v1/patient/'
    this.setState({marcaciones: special})
    let patient_ = special.patient
    patient_.anticuagulado = special.anticuagulado
    patient_.controlPeso = special.controlPeso
    patient_.cuidadoE = special.cuidadoE
    patient_.diabetico = special.diabetico
    patient_.estado = special.estado
    patient_.fase2 = special.fase2
    patient_.fragil = special.fragil
    patient_.oxigeno = special.oxigeno
    patient_.programaD = special.programaD
    patient_.reingreso = special.reingreso
    patient_.saturacion = special.saturacion
    patient_.alergias = special.alergias
    patient_.textAlergias = special.textAlergias
    if (this.state.update === true) {
      console.log(patient_)
    } else {
      patient_.fechaNacimiento = moment(patient_.fechaNacimiento).format('DD/MM/YYYY')
    }
    console.log(patient_)
    request
    .put(endpoint)
    .use(NoCache)
    .set('Authorization', `Bearer ${getToken()}`)
    .send(patient_)
    .end((err, res) => {
      if (err) console.log(err)
      else {
        this.setState({update: true, obj: patient_, birthdate: patient_.fechaNacimiento})
      }
    })
  }

  showTextBox (val) {
    this.setState({marcaciones: val})
  }

  render () {
    var estado
    var oxigeno
    var anticuagulado
    var diabetico
    var cuidadoE
    var controlPeso
    var saturacion
    var fragil
    var fase2
    var reingreso
    var programaD
    var alergias

    if (!_.isEmpty(this.state.obj)) {
      oxigeno = this.state.obj.oxigeno
      anticuagulado = this.state.obj.anticuagulado
      diabetico = this.state.obj.diabetico
      cuidadoE = this.state.obj.cuidadoE
      controlPeso = this.state.obj.controlPeso
      saturacion = this.state.obj.saturacion
      fragil = this.state.obj.fragil
      fase2 = this.state.obj.fase2
      reingreso = this.state.obj.reingreso
      programaD = this.state.obj.programaD
      estado = this.state.obj.estado
      alergias = this.state.obj.alergias
    } else {
      oxigeno = this.props.data.patientData.oxigeno
      anticuagulado = this.props.data.patientData.anticuagulado
      diabetico = this.props.data.patientData.diabetico
      cuidadoE = this.props.data.patientData.cuidadoE
      controlPeso = this.props.data.patientData.controlPeso
      saturacion = this.props.data.patientData.saturacion
      fragil = this.props.data.patientData.fragil
      fase2 = this.props.data.patientData.fase2
      reingreso = this.props.data.patientData.reingreso
      programaD = this.props.data.patientData.programaD
      estado = this.props.data.patientData.estado
      alergias = this.props.data.patientData.alergias
    }
    return (
      <div className='dashboard-medical-container'>
        <div className='header-conditions-data'>
          <SpecialConditions onSaveSpecial={this.saveSpecial.bind(this)} showTextBoxParent={this.showTextBox.bind(this)} data={this.props.identification} />
        </div>
        <div className='patient-special-information'>
          <div className='special-conditions-container'>
            <label className='data' id='Marcaciones'></label>
          </div>
          <div className='special-conditions-data special-data-top'>
            <div className='marcacion-label'>{(saturacion === true) ? <img className='special-img' src={SaturacionImage}/> : null}</div>
            <div className='marcacion-label'>{(oxigeno === true) ? <img className='special-img' src={OxigenoImage}/> : null}</div>
            <div className='marcacion-label'>{(diabetico === true) ? <img className='special-img' src={DiabeticoImage}/> : null}</div>
            <div className='marcacion-label'>{(fragil === true) ? <img className='special-img' src={FragilImage}/> : null}</div>
            <div className='marcacion-label'>{(estado === true) ? <img className='special-img' src={InactivoImage}/> : null}</div>
            <div className='marcacion-label'>{(fase2 === true) ? <img className='special-img' src={FaseIIImage}/> : null}</div>
          </div>
          <div className='special-conditions-data'>
            <div className='marcacion-label'>{(cuidadoE === true) ? <img className='special-img' src={CuidadoEImage}/> : null}</div>
            <div className='marcacion-label'>{(anticuagulado === true) ? <img className='special-img' src={AnticuagImage}/> : null}</div>
            <div className='marcacion-label'>{(controlPeso === true) ? <img className='special-img' src={ControlPImage}/> : null}</div>
            <div className='marcacion-label'>{(reingreso === true) ? <img className='special-img' src={ReingresoImage}/> : null}</div>
            <div className='marcacion-label'>{(programaD === true) ? <img className='special-img' src={ProgramaDImage}/> : null}</div>
            <div className='marcacion-label'>{(alergias === true) ? <img className='special-img' src={AlergiasImage}/> : null}</div>
          </div>
        </div>
      </div>
    )
  }
}

/* Validate Props */
MarcacionesComponent.propTypes = {
  data: React.PropTypes.object,
  identification: React.PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardSpecialCondition.js